<template>
  <v-card>
    <v-card-title>Apply Config From Simulator OPTIONS</v-card-title>
    <v-row>
      <v-card elevation="0" class="pa-2 mx-10" min-height="670" max-height="670">
        <v-row class="pt-1">
          <v-col cols="0" sm="0" md="0">
            <v-card
                    min-width="450"
                    max-width="450"
                    class="pa-4 my-0"
                    elevation="0"
                    outlined
            >
              <v-row>
                <v-col cols="1">
                  <v-checkbox
                          v-model="pAutomateConfig.isGenBalanceItem"
                          class="pt-0 mt-2"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <div class="font-weight-black pl-2 pr-3 pt-2">Generate Balance items (require)</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-1">
                  <v-card max-width="450"
                          elevation="0">
                    <v-text-field
                            label="Mulitiplier Gold Bonus"
                            v-model="pAutomateConfig.optionalRatioGoldItem"
                            type="number"
                            :disabled="!pAutomateConfig.isGenBalanceItem"
                            :step="0.01"
                    />
                  </v-card>
                </v-col>
                <v-col class="pt-1">
                  <v-card max-width="450"
                          elevation="0">
                    <v-text-field
                            label="Cost On Gold Drop Percent (%)"
                            v-model="pAutomateConfig.costOnGoldDropPercent"
                            type="number"
                            :disabled="!pAutomateConfig.isGenBalanceItem"
                            :step="0.01"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col class="pt-0 pl-3">
                  <v-card
                          min-width="450"
                          max-width="450"
                          class="pa-4 my-0"
                          elevation="0"
                          outlined
                  >
                    <v-row>
                      <v-col cols="1">
                        <v-checkbox
                                v-model="pAutomateConfig.isCustomRevive"
                                class="pt-0 mt-2"
                        >
                        </v-checkbox>
                      </v-col>
                      <v-col>
                        <div class="font-weight-black pl-2 pr-3 pt-2">Include revive items (optional)</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pt-1">
                        <v-text-field
                                label="Level Start Gen Revive Hero Item"
                                v-model="pAutomateConfig.levelStartHeroRevive"
                                type="number"
                                :disabled="!pAutomateConfig.isCustomRevive"
                                :step="1"
                        />
                      </v-col>
                      <v-col class="pt-2">
                        <v-checkbox
                                  v-model="pAutomateConfig.isIncludeSupportRevive"
                                  class="pt-0 mt-2"
                                  :disabled="!pAutomateConfig.isCustomRevive"
                                  label="Include support revive"
                          >
                          </v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
        </v-row>
        <v-row class="pt-0">
          <v-col cols="0" sm="0" md="0">
            <v-card
                    min-width="450"
                    max-width="450"
                    class="pa-4 my-0"
                    elevation="0"
                    outlined
            >
              <v-row>
                <v-col cols="1">
                  <v-checkbox
                          v-model="pAutomateConfig.isIncludeDmg"
                          class="pt-0 mt-2"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <div class="font-weight-black pl-2 pr-3 pt-2">Dmg Items</div>
                </v-col>
                <v-col cols="1">
                  <v-checkbox
                          :disabled="!pAutomateConfig.isIncludeDmg"
                          v-model="pAutomateConfig.isExtraDmg"
                          class="pt-0 mt-2"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <div v-if="pAutomateConfig.isIncludeDmg" class="font-weight-black pl-2 pr-3 pt-2">Extra Damage</div>
                  <div v-else class="font-weight-gray pl-2 pr-3 pt-2">Extra Damage</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-1">
                  <v-text-field
                          label="Bonus percentage for dmg (%)"
                          v-model="pAutomateConfig.dmgPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncludeDmg"
                          :step="0.01"
                  />
                </v-col>
                <v-col class="pt-1">
                  <v-text-field
                          label="Cost On damage Percent (%)"
                          v-model="pAutomateConfig.costOnDmgPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncludeDmg"
                          :step="0.01"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="0" sm="0" md="0" class="pl-3">
            <v-card
                    min-width="450"
                    max-width="450"
                    class="pa-4 my-0"
                    elevation="0"
                    outlined
            >
              <v-row>
                <v-col cols="1">
                  <v-checkbox
                          v-model="pAutomateConfig.isIncludeHp"
                          class="pt-0 mt-2"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <div class="font-weight-black pl-2 pr-3 pt-2">Hp Items</div>
                </v-col>
                <v-col cols="1">
                  <v-checkbox
                          :disabled="!pAutomateConfig.isIncludeHp"
                          v-model="pAutomateConfig.isExtraHp"
                          class="pt-0 mt-2"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <div v-if="pAutomateConfig.isIncludeHp" class="font-weight-black pl-2 pr-3 pt-2">Extra Hp</div>
                  <div v-else class="font-weight-gray pl-2 pr-3 pt-2">Extra Hp</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-1">
                  <v-text-field
                          label="Bonus percentage for hp (%)"
                          v-model="pAutomateConfig.hpPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncludeHp"
                          :step="0.01"
                  />
                </v-col>
                <v-col class="pt-1">
                  <v-text-field
                          label="Cost On hp Percent (%)"
                          v-model="pAutomateConfig.costOnHpPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncludeHp"
                          :step="0.01"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="pt-3">
          <v-col cols="0" sm="0" md="0">
            <v-card
                    min-width="450"
                    max-width="450"
                    class="pa-4 my-0"
                    elevation="0"
                    outlined
            >
              <v-row>
                <v-col cols="1">
                  <v-checkbox
                          v-model="pAutomateConfig.isIncSpeedItem"
                          class="pt-0 mt-2"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <div class="font-weight-black pl-2 pr-3 pt-2">Increase Speed Items (optional)</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-1">
                  <v-text-field
                          label="Bonus percentage for IncSpeed (%)"
                          v-model="pAutomateConfig.incSpeedPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncSpeedItem"
                          :step="0.01"
                  />
                </v-col>
                <v-col class="pt-1">
                  <v-text-field
                          label="Cost On IncSpeed Percent (%)"
                          v-model="pAutomateConfig.costOnIncSpeedPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncSpeedItem"
                          :step="0.01"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col class="pt-0">
            <v-card
                    min-width="450"
                    max-width="450"
                    class="pa-4 my-0"
                    elevation="0"
                    outlined
            >
              <v-row>
                <v-col cols="1">
                  <v-checkbox
                          v-model="pAutomateConfig.isIncManaItem"
                          class="pt-0 mt-2"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <div class="font-weight-black pl-2 pr-3 pt-2">Increase Mana Items (optional)</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-1">
                  <v-text-field
                          label="Bonus percentage for IncMana (%)"
                          v-model="pAutomateConfig.incManaPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncManaItem"
                          :step="0.01"
                  />
                </v-col>
                <v-col class="pt-1">
                  <v-text-field
                          label="Cost On IncMana Percent (%)"
                          v-model="pAutomateConfig.costOnIncManaPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncManaItem"
                          :step="0.01"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col class="pl-0 pt-0">
            <v-card
                    min-width="450"
                    max-width="450"
                    class="pa-4 my-0"
                    elevation="0"
                    outlined
            >
              <v-row>
                <v-col cols="1">
                  <v-checkbox
                          v-model="pAutomateConfig.isIncludeStunBoss"
                          class="pt-0 mt-2"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <div class="font-weight-black pl-2 pr-3 pt-2">Stun Boss Items (optional)</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-1">
                  <v-text-field
                          label="Bonus percentage for Stun (%)"
                          v-model="pAutomateConfig.bonusStunPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncludeStunBoss"
                          :step="0.01"
                  />
                </v-col>
                <v-col class="pt-1">
                  <v-text-field
                          label="Cost On Stun Percent (%)"
                          v-model="pAutomateConfig.costOnStunPercent"
                          type="number"
                          :disabled="!pAutomateConfig.isIncludeStunBoss"
                          :step="0.01"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="pt-4 pl-0">
          <v-col>
            <v-btn
                    class="ma-2"
                    color="red"
                    @click="resetCounter()"
            >
              Reset Counter
            </v-btn>
            <v-btn
                    class="mr-2"
                    color="orange"
                    @click="applyConfig()"
            >
              Apply Config Simulator
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-card>
</template>

<script>
  export default {
    name: "AutomateOptionPopup",
    props: ["pAutomateConfig"],
    components: {
      //UnityEnvironmentConfig
    },
    methods:{
      applyConfig(){
        this.$emit('applyConfig');
      },
      resetCounter(){
        this.$emit('resetCounter');
      },
    },
  }
</script>

<style scoped>

</style>